
import { StepProps } from '.'
import *as backend from '../../store/backend'
import { cToF } from '../../utils'


export type StepItemPorps = {
  isDelete?: boolean
  onDelete(number: number): void
  number: number
  select: boolean
  step: (backend.Step & {
    step?: number;
    currentTime?: number;  // 当前步骤已耗时
    totalTime?: number;  // 当前步骤总耗时
  })
  style?: React.CSSProperties
  //0-100
  state: backend.ActiveLogAck['data']['state'] | 'LOGGING' | 'LOGGED'

  unit?: 'C' | 'F' | undefined

}

export function StepItem(props: StepItemPorps) {
  const unit = props.unit === 'F' ? '℉' : '℃'

  let time = "";


  if (props.step.day === -1) {

    time = '∞'

  } else {


    if (Number(props.step.day) >= 0 && Number(props.step.day) < 10) {
      time += ("0" + props.step.day).substr(-2) + "d:";
    } else {
      time += (props.step.day === -1 ? '∞' : props.step.day) + "d:";
    }

    if (Number(props.step.hour) >= 0 && Number(props.step.hour) < 10) {
      time += ("0" + props.step.hour).substr(-2) + "h:";
    } else {
      time += props.step.hour + "h:";
    }

    if (Number(props.step.minutes) >= 0 && Number(props.step.minutes) < 10) {
      time += ("0" + props.step.minutes).substr(-2) + "m";
    } else {
      time += props.step.minutes + "m";
    }


  }



  const progress = ((props.step.currentTime || 0) / (props.step.totalTime || 0) || 0) * 100

  // 删除当前step
  function onClickByDeleteStep() {
    props.onDelete(props.number)
  }

  let colors = []
  switch (props.state) {
    case 'FINISHED':
    case 'DRAFT': {
      colors = [
        '',
        '',
        '',
        '',
      ]
    }
      break
    default: {
      colors = [
        'bg-stepColor1',
        'bg-stepColor2',
        'bg-stepColor3',
        'bg-stepColor4',
      ]
    }
  }


  return (
    <div
      className={`flex ${['LOGGED', 'LOGGING', 'FINISHED'].some(key => key === props.state) ? 'border-2' : props.select ? 'border-4' : 'border-2'} border-white rounded-3xl  font-black text-white bg-quickStartLeftStepContentBgColor  w-[330px]`}
      style={{
        opacity: ['LOGGED', 'LOGGING', 'FINISHED'].some(key => key === props.state) ? 1 : props.select ? 1 : 0.5,
        flexDirection: 'column',
        height: 107,
        overflow: 'hidden',
        ...props.style || {}
      }}
    >
      <div className={`flex ${colors[props.number - 1]}`}
        style={{
          justifyContent: 'space-between',
          alignItems: 'center',
          paddingRight: 10,
          paddingLeft: 10,
          flex: 1,
          fontWeight: 700,
          fontSize: 32,
        }}
      >
        <span>Step {props.number}</span>

        {(() => {

          switch (props.state) {
            case 'DRAFT': {
              return (
                <>
                  {props.isDelete ? (
                    <div
                      className="bg-buttonDefaultBgColor flex"
                      onClick={onClickByDeleteStep}
                      style={{
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderRadius: 29,
                        fontSize: 20,
                        fontWeight: 600,
                        width: 35,
                        height: 29,
                      }}
                    >X</div>
                  ) : null}
                </>
              )
            }

            case 'EDITING': {

              return (
                <>
                  {progress <= 0 ? (
                    <div
                      className="bg-buttonDefaultBgColor flex"
                      onClick={onClickByDeleteStep}
                      style={{
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderRadius: 29,
                        fontSize: 20,
                        fontWeight: 600,
                        width: 35,
                        height: 29,
                      }}
                    >X</div>
                  ) : null}
                </>
              )
            }
            case 'ACTIVE': {
              return (
                <>
                </>
              )
            }
          }

        })()}


      </div>

      {(() => {

        switch (props.state) {
          case 'DRAFT': {
            return (
              <div
                style={{
                  backgroundColor: 'white',
                  height: 10,
                }}
              />
            )
          }
          case 'EDITING':
          case 'ACTIVE': {
            return (
              <div
                style={{
                  backgroundColor: 'white',
                  height: 10,
                }}
              >
                <div
                  style={{
                    width: `${progress}%`,
                    height: '100%',
                    backgroundColor: '#676767',
                  }}
                />
              </div>

            )
          }



          case 'FINISHED':
          case 'LOGGING':
          case 'LOGGED': {
            return (
              <div
                style={{
                  backgroundColor: '#676767',
                  height: 10,
                }}
              />
            )
          }
        }

      })()}

      <div className="flex"
        style={{
          flex: 1,
          padding: '0px 10px',
          fontWeight: 400,
          fontSize: 28,
        }}
      >
        <span>
          {unit === '℉' ? cToF(props.step.temperature) : props.step.temperature}{unit} @ {time}
        </span>
      </div>

    </div>
  );
}


